const ACTION_TYPES = {
  SAVE_DYNAMICNODE_DATA: 'SAVE_DYNAMICNODE_DATA',
  RECEIVED_DYNAMICNODE_DATA: 'RECEIVED_DYNAMICNODE_DATA',
  UPDATE_DYNAMICNODE_DATA: 'UPDATE_DYNAMICNODE_DATA',
  SET_DYNAMICNODE_COORDS: 'SET_DYNAMICNODE_COORDS',
  RESET_DYNAMICNODE_DATA: 'RESET_DYNAMICNODE_DATA',
  SET_CURRENT_BOTSAYS_LANGUAGE: 'SET_DYNAMICNODE_CURRENT_BOTSAYS_LANGUAGE',
  UPDATE_BOTSAYS_EDITED_LANGUAGES: 'UPDATE_BOTSAYS_EDITED_LANGUAGES',
  UPDATE_BOTSAYS_ERRORS_IN_LANGUAGES: 'UPDATE_BOTSAYS_ERRORS_IN_LANGUAGES',
  SET_CURRENT_CHANNEL_ID: 'SET_CURRENT_BOTSAYS_CHANNEL_ID',
  UPDATE_BOT_RESPONSES_BY_CHANNEL: 'UPDATE_BOTSAYS_RESPONSES_BY_CHANNEL',
  RECEIVED_ENTITIES_LIST: 'RECEIVED_ENTITIES_LIST',
};

export default ACTION_TYPES;
